











































































































































































































































































































































































































































import { Vue, Prop, Component } from 'vue-property-decorator';

@Component({})
export default class CoinRotateBottomSmallIcon extends Vue {
  @Prop({ default: '129' }) readonly width?: string;
  @Prop({ default: '82' }) readonly height?: string;
}
